import { render } from "./App.vue?vue&type=template&id=4c967c88&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c967c88&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo/CheckDB130_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__